import { formatDate, convertESTToLocal } from "../../../components/formatDate";

export const filterServices = (services) => {
  return services.map(({ serviceOfferingID, createDate, ...rest }) => ({
    id: serviceOfferingID,  // Rename 'serviceOfferingID' to 'id'
    createDate: convertESTToLocal(createDate),  // Format 'createDate'
    ...rest  // Keep other properties unchanged
  }));
};